/** Reject gateway / HTML responses at the HTTP boundary, without exposing their body. */
export function invalidApiResponse(response) {
  const error = new Error(`HTTP ${response.status}`)
  error.code = 'INVALID_HTTP_RESPONSE'
  error.status = response.status
  return error
}

/** @param {Response} response */
export function apiJson(response) {
  const type = (response.headers.get('content-type') ?? '').split(';')[0].trim()
  if (!/^application\/(?:[\w.-]+\+)?json$/i.test(type)) throw invalidApiResponse(response)
  return response.json()
}
